export const Background =() => (
<svg width="81.8mm" height="67.836mm" version="1.1" viewBox="0 0 81.8 67.836" xmlns="http://www.w3.org/2000/svg">
    <g transform="translate(-96.389 -100.48)">
    <ellipse cx="145.43" cy="139.3" rx="31.907" ry="28.16" fill="#012169" stroke="#fff" stroke-width="1.6956"/>
    <ellipse cx="119.55" cy="142.71" rx="23.161" ry="20.776" fill="#418fde" fill-opacity=".81526"/>
    <ellipse cx="132.66" cy="117.17" rx="18.222" ry="16.689" fill="#a20067" fill-opacity=".67872"/>
    </g>
</svg>
)